exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#gift-pack-details.completed {\n  max-width: unset;\n  display: block; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/pages/completed/completed.scss
// module id = 656
// module chunks = 0